import { render, staticRenderFns } from "./buscar_en_historico.vue?vue&type=template&id=daf00058"
import script from "./buscar_en_historico.vue?vue&type=script&lang=js"
export * from "./buscar_en_historico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports